import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Home from './Home';
import SourceDetail from './SourceDetail';
import './EnterpriseDataLandscape.css';

// Route shell for the Enterprise Data Landscape (sibling of SensitiveDataLandscape/index.js):
// the home tile grid, and the per-source detail (area overview + findings ledger).
const EnterpriseDataLandscape = () => {
  const { path } = useRouteMatch();
  return (
    <div className='p-0'>
      <Container className='h-100' fluid>
        <Row>
          <Col className='p-0'>
            <Switch>
              <Route exact path={`${path}`}>
                <Home />
              </Route>
              {/* NOT exact: SourceDetail owns the nested /source/:id (areas) and
                  /source/:id/findings (ledger) routes. */}
              <Route path={`${path}/source/:id`}>
                <SourceDetail />
              </Route>
            </Switch>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EnterpriseDataLandscape;
